import React, { Component } from "react";
import languages from "constants/languages";
import AudienceBaseClause from "components/Common/Clauses/AudienceBase";
import ToggleableSelect from "components/Common/Clauses/ToggleableSelect";
import { getChosenLanguageLabel } from "helpers/locales";
import "components/Common/Clauses/Language/style.scss";

class LanguageClause extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { clause, readOnly, updateClause } = this.props;

    const operatorOptions = [
      { value: false, label: "is" },
      { value: true, label: "isn't" }
    ];

    const operatorDisplay = operatorOptions.find(
      option => option.value === !!clause.negative
    );

    const chosenLanguage = languages.find(language => {
      return language.code === clause.value;
    });

    let chosenLanguageDisplay;

    chosenLanguageDisplay = chosenLanguage
      ? getChosenLanguageLabel(chosenLanguage)
      : "";

    return (
      <AudienceBaseClause {...this.props}>
        <div className="language-targeting sub-clause">
          <ToggleableSelect
            readOnlyContent={operatorDisplay.label}
            className="select-negative"
            clearable={false}
            value={!!clause.negative}
            options={operatorOptions}
            autosize={false}
            onChange={opt => {
              updateClause(clause.id, { negative: opt.value });
            }}
            operator
            readOnly={readOnly}
          />
          <ToggleableSelect
            className="select-language"
            clearable={false}
            readOnlyContent={chosenLanguageDisplay}
            value={clause.value}
            options={languages.map(lang => {
              const label = getChosenLanguageLabel(lang);

              return {
                value: lang.code,
                label
              };
            })}
            autosize={false}
            onChange={opt => {
              updateClause(clause.id, { value: opt.value });
            }}
            autocomplete="off"
            readOnly={readOnly}
          />
        </div>
      </AudienceBaseClause>
    );
  }
}

export default LanguageClause;
